export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_19-30f33215b819318c8609dccbfe143dc5.jpg";